export default "__VITE_ASSET__84ec2364__"